import React, { useContext, useState, useCallback, useMemo, useEffect } from "react";
import { Modal, Button, message } from "antd";
import "./index.less";
import { Avatar } from "@/baseComponents/Avatar";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { FocusSDK } from "@/utils";
import { changeEgovUrl } from "@/utils/tools";
import { connect } from "dvajs";
import ChatState from "@/types/chat/State";
import { Employee } from "@/types/chat";
import iconJzb from "@/assets/img/icon-jzb_thumbnail.png";
import colors from "../styles/colors";
import { useTranslation } from "react-i18next";
import { resetAvatar} from "@/api/addressBook";
import { v4 } from 'uuid';
import request from 'axios';
import http from "https";

interface QRCodeProp {
  visible: boolean;
  onCancel: () => void;
  currentEmployee: Employee;
  updateCurrentEmployee: Function;
}

function RestoreDefaultAvata(props: QRCodeProp) {
  const [avatarSrc, setAvatarSrc] = useState(""); // 初始状态设为默认
  const [avatarReady, setAvatarReady] = useState(false); // 初始状态设为默认
  const { t } = useTranslation("chat");
  const { t: comT } = useTranslation("common");
  const { visible, onCancel, currentEmployee, updateCurrentEmployee } = props;
  const { authInfo, setAuthInfo } = useContext<GlobalContextConfig>(GlobalContext);
  const { app: appId, teamId, name, nickName, avatar: headImg } = currentEmployee || {};
  // 获取网关接口需要的参数
  const { service, authInfo: authData } = useContext<GlobalContextConfig>(
    GlobalContext
  );
  console.log("getSingleSessionDefaultAvatar", service, authData);

  const userName = useMemo(() => {
    return name ? name : nickName;
  }, [name, nickName]);

    useEffect(() => {
    // 定义一个异步函数来获取默认头像
    const fetchAvatar = async () => {
      try {
      const result = await getSingleSessionDefaultAvatar();
        
        setAvatarSrc(result);
        setAvatarReady(true);
      } catch (error) {
        console.error('获取用户头像失败:', error);
        // 可以选择保持默认头像，或者设置一个错误状态的头像
        setAvatarSrc("");
        setAvatarReady(true);
      }
    };
    fetchAvatar();
  }, []); 

   async function getSingleSessionDefaultAvatar() {
    try {
      const appId = authData?.ddAppId;
      const userId = authData?.userId;
      const teamId = authData?.teamUserInfo?.teamId
      const headers: any = {
        'x-client': service.appRuntime.registryConfig.client,
        'x-ts': `${Date.now()}`,
        'x-gw-version': '2',
        'x-app': service.appRuntime.envConfig.gateway.appId,
        'x-api': 'ebook.avatar.getDefaultAvatar',
        'x-nonce': v4(),
        'x-stage': service.appRuntime.envConfig.gateway.stage,
        // 'x-did': this.config.combinedData.machineId,
        'x-team-id': authData?.teamUserInfo?.teamId,
        'x-token': authData?.accessToken
      };
      const url = `https://${service.appRuntime.envConfig.gateway.host}/ebook.avatar.getDefaultAvatar?appId=${appId}&teamId=${teamId}&userId=${userId}`;
      
      let certificateParam = {};
      const { IS_PRIVATE_NET } = global as any;
      if (IS_PRIVATE_NET) {
        certificateParam = {
          httpsAgent: new http.Agent({
            rejectUnauthorized: false
          })
        };
      }
      const resp = await request({
        url,
        method: 'GET',
        headers,
        responseType: 'arraybuffer',
        ...certificateParam
      });

      if (resp.status !== 200) {
        return '';
      }
      const contentType = resp.headers['Content-Type'] || 'image/png';
      const ext = contentType.split('/').pop();
      if (ext !== 'png' && ext !== 'jpg') {
        return '';
      }

      // 将图片数据转为 base64 字符串用于前端渲染
      const buf = Buffer.from(resp.data);
      const base64 = buf.toString('base64');
      const imageSrc = `data:${contentType};base64,${base64}`;
      return imageSrc;
    } catch (e) {
      return '';
    }
  }

  const onOk = useCallback(async () => {
    const [res, err]: any = await resetAvatar();
    if (err) {
      message.error(err);
      return;
    }
    const defaultAvatarUrl = res.headImg || "";
    // 更换头像 更新本地个人信息数据
    updateCurrentEmployee({ ...currentEmployee, avatar: defaultAvatarUrl});
    setAuthInfo({ ...authInfo, headImg: defaultAvatarUrl });
    onCancel();
  }, [avatarSrc, authInfo, currentEmployee, onCancel, setAuthInfo, updateCurrentEmployee]);

  const modalFooter = () => {
    return (
      <div>
        <Button
          style={{
            height: 30,
            border: "1px solid #dee0e3",
            borderRadius: "4px",
            color: `${colors.black2}`
          }}
          onClick={onCancel}
        >
          取消
        </Button>

        <Button
          className="primary-btn"
          type="primary"
          style={{
            height: 30,
            border: "none",
            backgroundColor: " @primary-color !important",
            borderRadius: "4px",
            fontSize: "14px",
            color: "#ffffff"
          }}
          onClick={() => {
            onOk();
          }}
        >
          确定
        </Button>
      </div>
    );
  };

  return (
    <Modal
      visible={visible}
      title="头像"
      width={350}
      centered={true}
      okText="保存"
      cancelText="取消"
      onCancel={onCancel}
      footer={modalFooter()}
      wrapClassName="defaultAvatar-modal"
    >
      <div className="defaultAvatar-con">
        <p className="defaultAvatar-title">确认恢复默认头像？</p>
        {avatarReady &&
        <Avatar
          src={avatarSrc}
          name={userName}
          styleObj={{
            width: 72,
            height: 72,
            fontSize: 26,
            margin: "10px auto"
          }}
        />
        }
      </div>
    </Modal>
  );
}
export default connect(
  ({ chat }: { chat: ChatState }) => {
    return {
      currentEmployee: chat?.currentEmployee ? chat?.currentEmployee : {}
    };
  },
  (dispatch: any) => ({
    updateCurrentEmployee(payload: any) {
      dispatch({ type: "chat/updateCurrentEmployee", payload });
    }
  })
)(RestoreDefaultAvata);
